import { render, staticRenderFns } from "./IconOtherCommon.vue?vue&type=template&id=755bacc3"
import script from "./IconOtherCommon.vue?vue&type=script&lang=js"
export * from "./IconOtherCommon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports